import {$$, $} from './util';
import Swipe from 'swipejs/swipe';

(function () {
    $$('.gallery').forEach(gallery => {
        if ($$('.slider__item', gallery).length < 2) return;

        let slider = $('.slider', gallery);

        let sw = new Swipe(slider, {
            startSlide: 0,
            speed: 400,
            auto: 3000,
            draggable: true,
            continuous: true,
            disableScroll: false,
            stopPropagation: false,
            callback: function (index, elem, dir) {
            },
            transitionEnd: function (index, elem) {
            }
        });

        let nav = $('.slider__nav', gallery);
        if (nav) {
            if (sw.getNumSlides() > 1) nav.classList.remove('hide');
            else return;

            let next = $('.slider__next', nav),
                prev = $('.slider__prev', nav);

            next.addEventListener('click', function (e) {
                event.preventDefault();
                sw.next();
                return false;
            });
            prev.addEventListener('click', function (e) {
                event.preventDefault();
                sw.prev();
            });
        }
    });
})();


// WEBPACK FOOTER //
// ./js/gallery.js